import { Component } from '@angular/core';
import { CalendarComponent } from '../../../shared/components/calendar/calendar.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RestaurantService } from '../../../shared/services/restaurant/restaurant.service';

@Component({
  selector: 'app-calendar-restaurant',
  imports: [
    CalendarComponent,
    MatDividerModule,
    MatInputModule,
    MatFormFieldModule,
  ],
  templateUrl: './calendar-restaurant.component.html',
  styleUrls: ['./calendar-restaurant.component.css', '../../../shared/styles/layout.css'],
})
export class CalendarRestaurantComponent {
  constructor(private restaurantService: RestaurantService) {}

  eventDays: any[] = [];
  blockedDays: any[] = [];
  dataLoaded: boolean = false;
  thisMonthBlockedDays: any[] = [];
  thisMonthEventDays: any[] = [];
  currentMonth: number = new Date().getMonth();
  currentYear: number = new Date().getFullYear();

  ngOnInit() {
    this.restaurantService.getBlockedDays().subscribe({
      next: (blocked) => {
        this.blockedDays = blocked.filter(
          (day) =>
            day.block_type === 'HOLIDAY' || day.block_type === 'NO_SERVICE'
        );

        this.eventDays = blocked.filter((day) => day.block_type === 'EVENT');
        // console.debug('Event days', this.eventDays);
        // console.debug('Blocked days', this.blockedDays);

        // Filter days for the current month
        this.updateMonthlyDays();

        // Mark data as loaded after processing is complete
        this.dataLoaded = true;
      },
      error: (error) => {
        console.error('Error getting blocked days', error);
        this.dataLoaded = true; // Set to true even on error to avoid hanging
      },
    });
  }

  // Handle month change from calendar component
  onMonthChanged(event: { month: number; year: number }) {
    this.currentMonth = event.month;
    this.currentYear = event.year;
    this.updateMonthlyDays();
  }

  // Filter days for the current month
  updateMonthlyDays() {
    // Filter blocked days for current month
    this.thisMonthBlockedDays = this.blockedDays.filter((day) => {
      const date = new Date(day.date);
      return (
        date.getMonth() === this.currentMonth &&
        date.getFullYear() === this.currentYear
      );
    });

    // Filter event days for current month
    this.thisMonthEventDays = this.eventDays.filter((day) => {
      const date = new Date(day.date);
      return (
        date.getMonth() === this.currentMonth &&
        date.getFullYear() === this.currentYear
      );
    });

    // console.debug('This month blocked days', this.thisMonthBlockedDays);
    // console.debug('This month event days', this.thisMonthEventDays);
  }

  // Format date to display (DD/MM/YYYY)
  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
}
